module.exports = __webpack_public_path__ + "img/lupa-contract.6e0e21a5.svg";